import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { isMobile } from 'react-device-detect';
// components
import PatientTest from '../../organisms/patientTest';
// types
import { stateType, windowLocation } from '../../../types/types';
// helpers
import { handleConnectRoute, useWindowSize } from '../../../tools';
// localization
import strings from '../../../localization';
import { useLocation } from 'react-router-dom';
import AppTemplate from '../../templates/appTemplate';
import './index.scss';
import { useTheme } from '../../../hooks/theme';
interface PatientTestPageProps {
  location: { state?: { roomId: string; testType: string; inputType: string } };
  isIntegration: boolean;
}

const PatientTestPage: FC<PatientTestPageProps> = ({ isIntegration }: PatientTestPageProps) => {
  const [isConnected, setIsConnected] = useState<boolean>(false);
  const [isUserConnected, setIsUserConnected] = useState<boolean>(false);
  const { state: locationState } = useLocation<windowLocation>();

  const history = useHistory();
  const [windowWidth, windowHeight] = useWindowSize();
  const height = windowHeight > windowWidth && isMobile;
  const locationInputType = locationState?.inputType;
  const { isDark } = useTheme();

  // store
  const appLoading = useSelector((rootState: stateType) => rootState.app.loading);
  const dyops = useSelector((rootState: stateType) => rootState.dyops.dyops);

  // redirect to connect page if user tried to get to test page without room number
  useEffect(() => {
    const redirect = () => {
      history.push('/connect');
    };

    !locationState && redirect();
  }, []);

  const handleSubmit = () => {
    if (isDark) {
      history.push({
        pathname: '/end_test',
        state: {
          ...locationState,
          isPatient: true,
        },
      });
    } else {
      history.push({
        pathname: handleConnectRoute(locationInputType ? locationInputType : ''),
        state: locationState,
      });
    }
  };

  const handleCancel = () => {
    history.push({
      pathname: handleConnectRoute(locationInputType ? locationInputType : ''),
      state: locationState,
    });
  };

  const isSelfPrep =
    locationInputType === 'selfTest' && !dyops.isStarted && (dyops.closeLeftEye || dyops.closeRightEye);

  // Always apply `.test` on this route so stage bg/padding apply before socket connect (avoids chrome gutter flash).
  const templateClassName = ['test', isDark ? 'dark' : '', isSelfPrep ? 'self' : ''].filter(Boolean).join(' ');

  return (
    <AppTemplate
      className={` ${templateClassName}`}
      heading=""
      description=""
      height={height}
      isHeaderHidden
      submitLabel={strings.testPage.disconnect}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      submitHidden={!(!appLoading.status && isConnected)}
      isConnectStatusShown={!appLoading.status && isConnected}
      isUserConnected={isUserConnected}
      customUserType={`${locationInputType === 'selfTest' ? 'Second device' : 'Doctor'}`}
    >
      {locationState && (
        <PatientTest
          state={locationState}
          appLoading={appLoading}
          isConnected={isConnected}
          setIsConnected={setIsConnected}
          setIsUserConnected={setIsUserConnected}
          isUserConnected={isUserConnected}
          height={height}
          dyops={dyops}
          isIntegration={isIntegration}
        />
      )}
    </AppTemplate>
  );
};

export default PatientTestPage;
